import { render, staticRenderFns } from "./OrderChat.vue?vue&type=template&id=0fc9683f&"
import script from "./OrderChat.vue?vue&type=script&lang=js&"
export * from "./OrderChat.vue?vue&type=script&lang=js&"
import style0 from "./OrderChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports